import { configureStore } from '@reduxjs/toolkit';
import pageStateReducer from './pageStateSlice';
import dateReducer from './dateSlice';

const store = configureStore({
  reducer: {
    pageState: pageStateReducer,
    date: dateReducer
  },
});

export default store;
